/* PagingDeviceFeed.js */

"use strict";
const PagingFeed = require("../../../../../../lib/PagingFeed");
const _ = require("lodash");
const without = require("lodash/fp/without");

class PagingDeviceFeed extends PagingFeed {
    _getFeed(options) {
        // get initial entity feed object
        this._entityType = _.get(options, "entityType");
        this._mongoIdOperator = _.get(options, "mongoIdOperator");
        this._filter = _.get(options, "filter");
        this._userQuery = {id: {}};
        this._systemQuery = _.get(options, "systemQuery");
        if (this._filter) {
            _.assign(this._userQuery, this._filter);
        }
        this._idQuery = {
            $userQuery: this._userQuery,
            $systemQuery: this._systemQuery,
        };
        this._setIds([]);

        return this._EntityDef.startQueryFeed(
            this._activeOrgId,
            this._entityType,
            this._idQuery,
            undefined,
            this._sort,
            this._initialPage
        );
    }
    _deviceAvilaFeedReestablish(filter) {
        if (!_.isEmpty(filter)) {
            _.assign(this._idQuery.$userQuery, filter);
        } else {
            delete this._idQuery.$userQuery.$or;
        }
        return this.reestablish();
    }
    _feedReestablish() {
        return this._feed.reestablishFeed(
            this._activeOrgId,
            this._idQuery,
            this._entityFields,
            this._sort
        );
    }

    _getFeedIdsForSelection(tenantId, selection) {
        selection.mongoQuery = this._idQuery || {};
        return this._EntityDef.loadIdsForSelection(tenantId, this._entityType, selection);
    }

    _getIds() {
        return _.get(this._idQuery, `$userQuery.id.${this._mongoIdOperator}`);
    }
    _setIds(ids) {
        return _.set(this._idQuery, `$userQuery.id.${this._mongoIdOperator}`, ids);
    }

    addIds(addIds) {
        this._setIds(_.union(addIds, this._getIds()));
        this.reestablish();
    }

    removeIds(removeIds) {
        this._setIds(without(removeIds, this._getIds()));
        this.reestablish();
    }

    removeAllIds() {
        this._setIds([]);
        this.reestablish();
    }
}

module.exports = PagingDeviceFeed;
